import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=028f66ae"
var script = {}


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Footer: require('/home/rohit/Documents/GitHub/aibuddha-website/components/Footer.vue').default})
